import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/ReferenceData`,
  scopes: ExtHubRequest,
});

api.createEntities([
  { name: 'GetDivisions' },
  { name: 'GetAnnuities' },
  { name: 'GetStates' },
  { name: 'GetSourceOfFunds' },
  { name: 'GetResponses' },
  { name: 'GetProductCodesBySoftwareID' },
]);

const GetDivisions = () => api.endpoints.GetDivisions.get();
const GetAnnuities = (product) =>
  product
    ? api.endpoints.GetAnnuities.getMultipleQueryString([
        { queryParam: 'product', queryVal: product },
      ])
    : api.endpoints.GetAnnuities.get();
const GetStates = () => api.endpoints.GetStates.get();
const GetSourceOfFunds = () => api.endpoints.GetSourceOfFunds.get();
const GetResponses = () => api.endpoints.GetResponses.get();
const GetProductCodesBySoftwareID = (id) =>
  api.endpoints.GetProductCodesBySoftwareID.getWithURI(id);

export {
  GetDivisions,
  GetAnnuities,
  GetStates,
  GetSourceOfFunds,
  GetResponses,
  GetProductCodesBySoftwareID,
};
